import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import { TrailResolver } from 'core/resolvers';
import { HomeComponent } from './home/home.component';
import { NotFoundComponent } from 'core/components/not-found/not-found.component';
import { EmailPreviewComponent } from './core';

const appRoutes: Routes = [
  {
    path: 'dashboard',
    title: 'appDashboard',
    loadChildren: () => import('app/dashboard/dashboard.module').then((m) => m.DashboardModule)
  },
  // TODO: clients/subscriptions route = CLEAN??
  {
    path: 'clients',
    title: 'appClients',
    loadChildren: () => import('app/clients/clients.module').then((m) => m.ClientsModule)
  },
  {
    path: 'groups',
    title: 'appGroups',
    loadChildren: () => import('app/groups/groups.module').then((m) => m.GroupsModule)
  },
  {
    path: 'mars',
    title: 'appMars',
    loadChildren: () => import('app/mars/mars.module').then((m) => m.MarsModule)
  },
  {
    path: 'students',
    title: 'appStudents',
    loadChildren: () => import('app/students/students.module').then((m) => m.StudentsModule)
  },
  {
    path: 'courses',
    title: 'appCourses',
    loadChildren: () => import('app/courses/courses.module').then((m) => m.CoursesModule)
  },
  {
    path: 'itineraries',
    title: 'appItineraries',
    loadChildren: () => import('app/itineraries/itineraries.module').then((m) => m.ItinerariesModule)
  },
  {
    path: 'distributors',
    title: 'appDistributors',
    loadChildren: () => import('app/distributors/distributors.module').then((m) => m.DistributorsModule)
  },
  {
    path: 'orders',
    title: 'appOrders',
    loadChildren: () => import('app/orders/orders.module').then((m) => m.OrdersModule)
  },
  {
    path: 'resources',
    title: 'appResources',
    loadChildren: () => import('app/resources/resources.module').then((m) => m.ResourcesModule)
  },
  {
    path: 'agents',
    title: 'appAgents',
    loadChildren: () => import('app/agents/agents.module').then((m) => m.AgentsModule)
  },
  {
    path: 'demos',
    title: 'appDemos',
    loadChildren: () => import('app/demos/demos.module').then((m) => m.DemosModule)
  },
  {
    path: 'games',
    title: 'appGames',
    loadChildren: () => import('app/games/games.module').then((m) => m.GamesModule)
  },
  {
    path: 'customizations',
    title: 'appCustomizations',
    loadChildren: () => import('app/customizations/customizations.module').then((m) => m.CustomizationsModule)
  },
  {
    path: 'settings',
    title: 'appSettings',
    loadChildren: () => import('app/settings/settings.module').then((m) => m.SettingsModule)
  },
  {
    path: 'monitor',
    title: 'appMonitor',
    loadChildren: () => import('app/monitor/monitor.module').then((m) => m.MonitorModule)
  },
  {
    path: 'roleplays',
    title: 'appRoleplays',
    loadChildren: () => import('app/roleplay/roleplay.module').then((m) => m.RoleplayModule)
  },
  // TODO: Clean??
  {
    path: 'mail',
    title: 'appMail',
    loadChildren: () => import('app/mail/mail.module').then((m) => m.MailModule)
  },
  // TODO: Clean??
  {
    path: 'documents',
    title: 'appDocuments',
    loadChildren: () => import('app/documents/documents.module').then((m) => m.DocumentsModule)
  },
  // TODO: Clean??
  {
    path: 'licenses',
    title: 'appLicenses',
    loadChildren: () => import('app/licenses/licenses.module').then((m) => m.LicensesModule)
  },
  // TODO: Clean??
  {
    path: 'questions',
    title: 'appQuestions',
    loadChildren: () => import('app/questions/questions.module').then((m) => m.QuestionsModule)
  },
  // TODO: Clean??
  {
    path: 'groups-tutorization',
    title: 'appGroupsTutorization',
    loadChildren: () =>
      import('app/groups-tutorization/groups-tutorization.module').then((m) => m.GroupsTutorizationModule)
  },
  // TODO: Clean??
  {
    path: 'reports',
    title: 'appReports',
    loadChildren: () => import('app/reports/reports.module').then((m) => m.ReportsModule)
  },
  {
    path: 'ranking',
    title: 'appRanking',
    loadChildren: () => import('app/ranking/ranking.module').then((m) => m.RankingModule)
  },
  // TODO: Clean??
  {
    path: 'credits',
    title: 'appCredits',
    loadChildren: () => import('app/credits/credits.module').then((m) => m.CreditsModule)
  },
  { path: '', title: 'admin', redirectTo: 'home', pathMatch: 'full', resolve: { trail: TrailResolver } },
  {
    path: 'login',
    title: 'appLogin',
    loadChildren: () => import('app/auth/auth.module').then((m) => m.AuthModule)
  },
  { path: 'home', title: 'home.label', component: HomeComponent, canActivate: [ProfileGuard] },
  { path: 'preview', title: 'appPreview', component: EmailPreviewComponent },
  { path: 'not-found', title: 'error.notFound', component: NotFoundComponent },
  { path: '**', title: 'appAny', redirectTo: 'not-found' }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
